import { Identifier } from "../../core";
export class MenuSectionId extends Identifier {
    constructor(id) {
        super("MenuSectionId", id);
    }
}
